import cn from 'classnames';
import { ReactNode } from 'react';

import './group.styles.scss';

type RadioCardGroupProps = {
    children: ReactNode;
    className?: string;
    testId?: string;
    name?: string;
};

export const RadioCardGroup = ({ children, className, testId, name }: RadioCardGroupProps) => {
    return (
        <fieldset className={cn('radio-card-group', className)} data-testid={testId} data-name={name}>
            {children}
        </fieldset>
    );
};
